import React from 'react'
import { storiesOf } from '@storybook/react'
import { withKnobs, boolean } from '@storybook/addon-knobs/react'

import SettingsScreen from 'routes/Settings/SettingsScreen'

import {
  NotificationSettingsResponse,
  EditProfileResponse,
  UserInfoResponse,
  GeneralResponse,
  User,
  NotificationType
} from 'protos'
import { withRouter } from 'react-router'
import noop from 'lodash-es/noop'
import Chance from 'chance'

import { fakeApiCall } from './utils'

// fake data
const chance = new Chance(0)

const randomUser = (options?: Object) =>
  User.fromObject({
    userId: chance.guid(),
    name: chance.name(),
    photoUrl: `http://i.pravatar.cc/128?img=${chance.integer({ min: 1, max: 70 })}`,
    ...options,
  })

// stories

storiesOf('SettingsScreen', module)
  .addDecorator(withKnobs)
  .add('default', () => {
    const badServer = boolean('badServer', false)

    const errorCode = badServer ? 'Could not retrieve data from the server.' : undefined

    const fakeUserResponse = UserInfoResponse.fromObject({
      user: randomUser(),
    })

    const fakeNotificationSettingsResponse = NotificationSettingsResponse.fromObject({
      notification: [
        NotificationType.fromObject({
          notificationId: '1',
          title: 'Enabled by default',
          enabled: true,
          available: true,
        }),
        NotificationType.fromObject({
          notificationId: '2',
          title: 'Disabled by default',
          enabled: false,
          available: true,
        }),
        NotificationType.fromObject({
          notificationId: '3',
          title: 'Cannot disable',
          enabled: true,
          available: false,
        }),
        NotificationType.fromObject({
          notificationId: '4',
          title: 'Cannot enable',
          enabled: false,
          available: false,
        }),
      ],
    })

    const changeUserResponse: [EditProfileResponse, GeneralResponse] = [
      EditProfileResponse.fromObject({ result: EditProfileResponse.Result.EPR_SUCCESS }),
      GeneralResponse.fromObject({ result: GeneralResponse.Result.GR_SUCCESS }),
    ]

    const SettingsContainer = withRouter(SettingsScreen)

    return (
      <SettingsContainer
        key={Number(badServer)}
        userInfo={fakeUserResponse}
        getNotifSettings={() => fakeApiCall(fakeNotificationSettingsResponse, 500, errorCode)}
        changeUser={() => fakeApiCall(changeUserResponse)}
        onUserInfoChange={noop}
        onLogoutClick={noop}
      />
    )
  })
